var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"footer"},[_c('button',{staticClass:"action",attrs:{"type":"button"},on:{"click":function($event){return _setup.emits('reset')}}},[_vm._v("Convert another GIF")])])
}
var staticRenderFns = []

export { render, staticRenderFns }